import { Theme, SxProps, Stack, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useScreenLargerThan } from '../lib/hooks/breakpoint-hooks';
import useTrackPageView from '../lib/hooks/use-track-page-view';
import Reporting from '../components/Reporting/Reporting';
import { ReportingModel } from '../lib/models/ReportingModel';
import { post } from '../lib/api';
import { AxiosResponse } from 'axios';
import { useDebounce } from 'usehooks-ts';
import { SearchProps } from '../lib/dtos/SearchProps';
import SearchBox from '../components/SearchBox/SearchBox';
import moment from 'moment';
import { INVALID_DATE } from '../components/Utils/InternalDatePicker';

const ReportingPage = () => {
    const trackPageView = useTrackPageView();

    const [data, setData] = useState<ReportingModel[]>([]);
    const [loading, setLoading] = useState(false);

    const [filterValue, setFilterValue] = useState('');
    const debouncedFilterValue = useDebounce(filterValue, 300);

    const [startDateValue, setStartDateValue] = useState(
        moment(new Date()).add(-1, 'day').toString()
    );
    const [endDateValue, setEndDateValue] = useState(moment(new Date()).toString());

    const isLargerThanSmall = useScreenLargerThan('sm');

    useEffect(() => {
        const handler = async () => {
            if (
                startDateValue.toString().toLowerCase() !== INVALID_DATE.toLowerCase() &&
                endDateValue.toString().toLowerCase() !== INVALID_DATE.toLowerCase()
            ) {
                setLoading(true);
                const data = await post<SearchProps, AxiosResponse<ReportingModel[]>>('getLogs', {
                    search: debouncedFilterValue,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    offset: new Date().getTimezoneOffset()
                });
                setLoading(false);
                setData(data.data);
            }
        };
        handler();
    }, [debouncedFilterValue, startDateValue, endDateValue]);

    useEffect(() => {
        trackPageView('Reporting Page');
    }, [trackPageView]);

    return (
        <Box sx={containerStyle(isLargerThanSmall)}>
            <SearchBox page="reporting" setFilter={setFilterValue} filterValue={filterValue} />
            <Stack direction={isLargerThanSmall ? 'row' : 'column'} gap={1}>
                <Reporting
                    data={data || []}
                    loading={loading}
                    inputDateProps={{
                        startDate: startDateValue,
                        setStartDate: setStartDateValue,
                        endDate: endDateValue,
                        setEndDate: setEndDateValue
                    }}
                />
            </Stack>
        </Box>
    );
};

const containerStyle: (media: boolean) => SxProps<Theme> = (media: boolean) => {
    const biggerThanSm: SxProps<Theme> = { padding: 3 };
    const smallerThanSm: SxProps<Theme> = {
        paddingX: 0
    };

    return media ? biggerThanSm : { width: '100%', ...biggerThanSm, ...smallerThanSm };
};

export default ReportingPage;
